import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

interface VideoProps {
  title: string;
  url: string;
  thumbnail?: string;
  category: string;
  description?: string;
}

const PlanetaTerraChamandoPage = () => {
  const [activeVideo, setActiveVideo] = useState<VideoProps | null>(null);
  
  const videos: VideoProps[] = [
    // Reino Animal
    {
      title: "Reino Animal - Episódio 1",
      url: "https://www.youtube.com/watch?v=vC1R75jV9JA",
      thumbnail: "https://i.ytimg.com/vi/vC1R75jV9JA/hqdefault.jpg",
      category: "reino-animal",
      description: "Documentário sobre o reino animal e suas maravilhas naturais."
    },
    {
      title: "Reino Animal - Episódio 2",
      url: "https://www.youtube.com/watch?v=6rFUecTOlV8",
      thumbnail: "https://i.ytimg.com/vi/6rFUecTOlV8/hqdefault.jpg",
      category: "reino-animal",
      description: "Continuação do documentário sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 3",
      url: "https://www.youtube.com/watch?v=KihLye04VeI",
      thumbnail: "https://i.ytimg.com/vi/KihLye04VeI/hqdefault.jpg",
      category: "reino-animal",
      description: "Terceiro episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 4",
      url: "https://www.youtube.com/watch?v=PXz8bFfQaqY",
      thumbnail: "https://i.ytimg.com/vi/PXz8bFfQaqY/hqdefault.jpg",
      category: "reino-animal",
      description: "Quarto episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 5",
      url: "https://www.youtube.com/watch?v=wLRxJolKSf0",
      thumbnail: "https://i.ytimg.com/vi/wLRxJolKSf0/hqdefault.jpg",
      category: "reino-animal",
      description: "Quinto episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 6",
      url: "https://www.youtube.com/watch?v=RJPFkroF7So",
      thumbnail: "https://i.ytimg.com/vi/RJPFkroF7So/hqdefault.jpg",
      category: "reino-animal",
      description: "Sexto episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 7",
      url: "https://www.youtube.com/watch?v=BJKOq-eg3uY",
      thumbnail: "https://i.ytimg.com/vi/BJKOq-eg3uY/hqdefault.jpg",
      category: "reino-animal",
      description: "Sétimo episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 8",
      url: "https://www.youtube.com/watch?v=4mZvl4RVGbw",
      thumbnail: "https://i.ytimg.com/vi/4mZvl4RVGbw/hqdefault.jpg",
      category: "reino-animal",
      description: "Oitavo episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 9",
      url: "https://www.youtube.com/watch?v=OUycv_CnNMI",
      thumbnail: "https://i.ytimg.com/vi/OUycv_CnNMI/hqdefault.jpg",
      category: "reino-animal",
      description: "Nono episódio da série sobre o reino animal."
    },
    {
      title: "Reino Animal - Episódio 10",
      url: "https://www.youtube.com/watch?v=IE2KbC43FAw",
      thumbnail: "https://i.ytimg.com/vi/IE2KbC43FAw/hqdefault.jpg",
      category: "reino-animal",
      description: "Décimo episódio da série sobre o reino animal."
    },
    
    // Planeta Selvagem
    {
      title: "Planeta Selvagem - Documentário",
      url: "https://www.youtube.com/watch?v=-DoVYtE7Mlk",
      thumbnail: "https://i.ytimg.com/vi/-DoVYtE7Mlk/hqdefault.jpg",
      category: "planeta-selvagem",
      description: "Documentário completo sobre o planeta selvagem e seus habitantes."
    },
    {
      title: "Planeta Selvagem 2",
      url: "https://www.youtube.com/watch?v=Kw4HN5AJt60",
      thumbnail: "https://i.ytimg.com/vi/Kw4HN5AJt60/hqdefault.jpg",
      category: "planeta-selvagem",
      description: "Segunda parte do documentário Planeta Selvagem."
    },
    
    // Zebras
    {
      title: "Zebras na Savana",
      url: "https://www.youtube.com/shorts/wV2kbN0flWc",
      thumbnail: "https://i.ytimg.com/vi/wV2kbN0flWc/hqdefault.jpg",
      category: "zebra",
      description: "Zebras vivendo livremente na savana africana."
    },
    {
      title: "Zebra - Comportamento",
      url: "https://www.youtube.com/watch?v=RlROA49MCO4",
      thumbnail: "https://i.ytimg.com/vi/RlROA49MCO4/hqdefault.jpg",
      category: "zebra",
      description: "Estudo sobre o comportamento das zebras em seu habitat natural."
    },
  ];
  
  const categories = [
    { id: "all", label: "Todos" },
    { id: "reino-animal", label: "Reino Animal" },
    { id: "planeta-selvagem", label: "Planeta Selvagem" },
    { id: "zebra", label: "Zebras" },
  ];
  
  const handleWatchVideo = (video: VideoProps) => {
    setActiveVideo(video);
  };
  
  const handleSubscribe = () => {
    toast.success("Inscrição realizada com sucesso! Você será redirecionado para o canal.", {
      duration: 3000,
    });
    setTimeout(() => {
      window.open("https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w", "_blank");
    }, 3000);
  };

  const handleRumbleRedirect = () => {
    window.open("https://rumble.com/register/FARIAS/", "_blank");
  };

  const handlePlanetaSubscribe = () => {
    window.open("https://rumble.com/c/planetaselvagem6", "_blank");
  };
  
  const formatEmbedUrl = (url: string) => {
    if (url.includes("youtube.com/watch")) {
      return url.replace("watch?v=", "embed/");
    } else if (url.includes("youtube.com/shorts")) {
      return url.replace("shorts/", "embed/");
    } else if (url.includes("youtube.com/live")) {
      return url.replace("live/", "embed/");
    }
    return url;
  };
  
  const renderVideoGrid = (category: string) => {
    const filteredVideos = category === "all" 
      ? videos 
      : videos.filter(video => video.category === category);
    
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredVideos.map((video, index) => (
          <Card key={index} className="overflow-hidden transition-transform hover:scale-105">
            <CardContent className="p-0">
              <div 
                className="aspect-video bg-muted bg-cover bg-center cursor-pointer"
                style={{ backgroundImage: `url(${video.thumbnail || "https://placehold.co/600x400?text=Video"})` }}
                onClick={() => handleWatchVideo(video)}
              >
                <div className="w-full h-full bg-black/30 flex items-center justify-center group hover:bg-black/50 transition-colors">
                  <Button variant="outline" className="bg-primary/80 text-primary-foreground border-none hover:bg-primary group-hover:scale-110 transition-transform">
                    Assistir
                  </Button>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium line-clamp-2 mb-2" title={video.title}>{video.title}</h3>
                <p className="text-muted-foreground text-sm line-clamp-2">{video.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-24 pb-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="rounded-lg overflow-hidden mb-8">
            <img
              src="https://storage.googleapis.com/fenado-ai-farm-public/generated/f2e84e3e-24cc-45a5-aa45-e2dfa65d32c6.webp"
              alt="Planeta Terra Chamando"
              className="w-full h-auto object-cover"
            />
          </div>
          
          <div className="flex flex-col md:flex-row gap-6 mb-8">
            <div className="md:w-3/5">
              <h1 className="text-3xl font-bold mb-4">Planeta Terra Chamando</h1>
              <p className="text-muted-foreground mb-4">
                Bem-vindo ao canal Planeta Terra Chamando! Aqui você encontrará documentários fascinantes sobre 
                nosso planeta, a vida selvagem e as maravilhas do reino animal. Explore nossos vídeos sobre 
                diferentes espécies, ecossistemas e fenômenos naturais.
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <Button onClick={handleSubscribe} className="bg-red-600 hover:bg-red-700 text-white">
                  Inscrever-se no YouTube
                </Button>
                <Button onClick={handlePlanetaSubscribe} variant="outline" className="border-primary text-primary hover:bg-primary/10">
                  Seguir no Rumble
                </Button>
              </div>
            </div>
            
            <div className="md:w-2/5 bg-card rounded-lg p-6 border border-border">
              <h2 className="text-xl font-semibold mb-4">Canais Relacionados</h2>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">PS</div>
                  <div>
                    <a href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
                      Planeta Selvagem 2
                    </a>
                    <p className="text-sm text-muted-foreground">Vídeos sobre o planeta selvagem</p>
                  </div>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">CC</div>
                  <div>
                    <a href="https://www.youtube.com/channel/UCYfW1FfL2OZk5u9-GakVKJg" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
                      CraftyCreations
                    </a>
                    <p className="text-sm text-muted-foreground">Vídeos de animais e vida selvagem</p>
                  </div>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">PS</div>
                  <div>
                    <a href="https://rumble.com/c/planetaselvagem6" target="_blank" rel="noopener noreferrer" className="font-medium hover:text-primary">
                      Planeta Selvagem 6 (Rumble)
                    </a>
                    <p className="text-sm text-muted-foreground">Nosso canal no Rumble</p>
                  </div>
                </li>
              </ul>
              
              <Separator className="my-4" />
              
              <h3 className="text-lg font-medium mb-3">Criar conta no Rumble</h3>
              <p className="text-sm text-muted-foreground mb-3">
                Crie sua conta no Rumble e acompanhe nossos vídeos também nessa plataforma.
              </p>
              <Button onClick={handleRumbleRedirect} className="w-full">
                Registrar no Rumble
              </Button>
            </div>
          </div>
          
          <Tabs defaultValue="all" className="w-full">
            <div className="overflow-x-auto pb-2">
              <TabsList className="mb-6">
                {categories.map((category) => (
                  <TabsTrigger key={category.id} value={category.id}>
                    {category.label}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>
            
            {categories.map((category) => (
              <TabsContent key={category.id} value={category.id} className="mt-0">
                {renderVideoGrid(category.id)}
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </main>
      
      <Dialog open={!!activeVideo} onOpenChange={(open) => !open && setActiveVideo(null)}>
        <DialogContent className="sm:max-w-4xl">
          <DialogHeader>
            <DialogTitle>{activeVideo?.title}</DialogTitle>
          </DialogHeader>
          <div className="aspect-video w-full">
            <iframe 
              src={activeVideo ? formatEmbedUrl(activeVideo.url) : ""} 
              className="w-full h-full" 
              allowFullScreen 
              title={activeVideo?.title}
            ></iframe>
          </div>
          <p className="text-muted-foreground">{activeVideo?.description}</p>
          <div className="flex justify-between">
            <Button onClick={handleSubscribe} className="bg-red-600 hover:bg-red-700 text-white">
              Inscrever-se no Canal
            </Button>
            <Button variant="outline" onClick={() => setActiveVideo(null)}>
              Fechar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      
      <Footer />
    </div>
  );
};

export default PlanetaTerraChamandoPage;